<!-- src/app/pages/boutique-page/boutique-page.component.html -->
<div class="boutique-page">
  <div class="boutique-header">
    <h1 class="boutique-title">Boutique</h1>
    <p class="boutique-subtitle">Nos services à la carte, prêts à être ajoutés à votre projet</p>
  </div>

  @if (selectedCount > 0) {
    <div class="cart-summary">
      <i class="fas fa-shopping-cart"></i>
      <span>{{ selectedCount }} service{{ selectedCount > 1 ? 's' : '' }} sélectionné{{ selectedCount > 1 ? 's' : '' }}</span>
      <span class="cart-total">{{ selectedTotal }} CHF</span>
    </div>
  }

  @for (category of categories; track category.title) {
    <section class="category">
      <div class="category-header">
        <div class="category-heading">
          <i class="fas" [ngClass]="category.icon"></i>
          <h2>{{ category.title }}</h2>
        </div>
        <span class="category-count">{{ category.services.length }} services</span>
      </div>

      <div class="services-grid">
        @for (service of category.services; track service.name) {
          <article class="service-card" [class.expanded]="expandedService === service.name">
            <div class="service-top">
              <h3 class="service-name">{{ service.name }}</h3>
              <div class="service-price">{{ service.price }} {{ service.currency }}</div>
            </div>

            <p class="service-summary">{{ service.summary }}</p>

            <div class="service-delivery">
              <i class="fas fa-clock"></i>
              <span>{{ service.delivery }}</span>
            </div>

            @if (expandedService === service.name) {
              <div class="service-details-panel">
                <p>{{ service.detail }}</p>
              </div>
            }

            <div class="service-actions">
              <button type="button" class="btn-details" (click)="toggleDetails(service.name)">
                {{ expandedService === service.name ? 'Réduire' : 'Détails' }}
              </button>
              <button
                type="button"
                class="btn-add"
                [class.added]="isSelected(service.name)"
                (click)="toggleSelect(service)"
              >
                <i class="fas" [ngClass]="isSelected(service.name) ? 'fa-check' : 'fa-plus'"></i>
                {{ isSelected(service.name) ? 'Ajouté' : 'Ajouter' }}
              </button>
            </div>
          </article>
        }
      </div>
    </section>
  }
</div>
